import { useQuery } from '@tanstack/react-query';
import { getMartingale } from '../lib/apiClient';

// The scorer runs every five minutes; a round settles every fifteen.
const STALE_TIME_MS = 2 * 60_000;

/** Martingale paper test on BTC 15m. Hypothetical only. */
export function useMartingale() {
  return useQuery({
    queryKey: ['btc15-martingale'],
    queryFn: getMartingale,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
